export default __webpack_public_path__ + "static/media/ndvi2.97e05163.PNG";